import { Chip, Typography } from "@mui/material";
import useLanguage from "../../../hooks/useLanguage";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Row } from "../style";

export default function RowChop({ form, name, label, handleToggleFileEdit }) {
  const [
    {
      pages: { configurations: text },
    },
  ] = useLanguage();

  return (
    <Row center="true" spacebetween="true">
      <Typography variant="h6">{label}:</Typography>
      <Chip
        name={name}
        icon={<RemoveRedEyeIcon fontSize="small" />}
        label={!!form[name] ? text.success : text.failure}
        color={!!form[name] ? "success" : "action"}
        onClick={() => handleToggleFileEdit(name)}
      />
    </Row>
  );
}
